import type { Resolver } from 'cpool-schemas';
import { divisionId } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = NonNullable<unknown>;

export const schemaDivisionResolver_GetIds = z.array(divisionId);

export type SchemaDivisionResolver_GetIds = z.infer<typeof schemaDivisionResolver_GetIds>;

export type DivisionResolver_GetIds = Resolver<Arguments, SchemaDivisionResolver_GetIds>;
